import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile_avatar"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  src: "https://firebasestorage.googleapis.com/v0/b/internaldev-361116.appspot.com/o/images%2Ftwitter-profile.jpg?alt=media&token=4eeb67d3-baed-4019-8681-08d1e8b086ea"
}
const _hoisted_4 = {
  key: 0,
  class: "profile_feeling"
}
const _hoisted_5 = {
  key: 1,
  class: "profile_feeling"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = {
  key: 2,
  class: "avatar"
}
const _hoisted_12 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["head", {
      'mx-0':
        (_ctx.addPostModel.sourceType &&
          _ctx.addPostModel.sourceType == 'data-team-tweets') ||
        (_ctx.addPostModel.userId && _ctx.addPostModel.userId.includes('rssfeed')),
    }])
      }, [
        (
        _ctx.addPostModel.sourceType == 'data-team-tweets' ||
        (_ctx.addPostModel.userId && _ctx.addPostModel.userId.includes('rssfeed'))
      )
          ? (_openBlock(), _createElementBlock("figure", _hoisted_1, [
              (_ctx.addPostModel.rssFeedDetail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.addPostModel.rssFeedDetail.profilePicture,
                    onError: _cache[0] || (_cache[0] = (ev) => _ctx.changePictureOnError(ev))
                  }, null, 40, _hoisted_2))
                : (_openBlock(), _createElementBlock("img", _hoisted_3))
            ]))
          : (_ctx.user.profilePicture)
            ? (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
                key: 1,
                profileImage: _ctx.user.profilePicture,
                userId: _ctx.user._id,
                user: _ctx.user,
                fromOutside: _ctx.fromOutside,
                class: _normalizeClass([!_ctx.isSavedPost ? 'mini connection' : '', _ctx.isSmallScreen && 'mini']),
                badges: false,
                border: true,
                isDetailPopUp: _ctx.isSavedPost,
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('avatar-click')), ["stop"]))
              }, null, 8, ["profileImage", "userId", "user", "fromOutside", "class", "isDetailPopUp"]))
            : _createCommentVNode("", true),
        _createElementVNode("h6", {
          class: "info_profile",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.goToProfile()), ["stop"]))
        }, [
          (
          _ctx.addPostModel.sourceType == 'data-team-tweets' ||
          (_ctx.addPostModel.userId && _ctx.addPostModel.userId.includes('rssfeed'))
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.addPostModel.rssFeedDetail)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.addPostModel.rssFeedDetail.name), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Twitter ")
                    ], 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.user.fullName), 1)),
          (_ctx.addPostModel.sourceType == 'rssfeed')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[3] || (_cache[3] = [
                _createElementVNode("b", null, " News ", -1)
              ])))
            : (_ctx.addPostModel.sourceType == 'data-team-tweets')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[4] || (_cache[4] = [
                  _createElementVNode("b", null, " Twitter Feed ", -1)
                ])))
              : (_ctx.addPostModel.sourceType == 'twitter-tweet')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t("common.common.shared")) + " ", 1),
                    _cache[5] || (_cache[5] = _createElementVNode("b", null, "Twitter Tweet", -1)),
                    _createTextVNode(" with " + _toDisplayString(_ctx.postPrivacy), 1)
                  ]))
                : (_ctx.postSubType && _ctx.isSavedPost)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.postSubType=='short'?_ctx.postSubType.toUpperCase() +" POST" :_ctx.postSubType.toUpperCase()), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.common.with")) + " " + _toDisplayString(_ctx.$t(`common.common.${_ctx.postPrivacy}`)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, " @" + _toDisplayString(_ctx.user.userName), 1))
        ]),
        (_ctx.postType && _ctx.isSavedPost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.addPostModel.userId && _ctx.addPostModel.userId.includes('rssfeed'))
                ? (_openBlock(), _createBlock(_component_IconComponent, {
                    key: 0,
                    path: "/explore",
                    icon: "icon-news.svg"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
            _ctx.addPostModel.postOnTwitter ||
            _ctx.addPostModel.sourceType == 'data-team-tweets' ||
            _ctx.addPostModel.sourceType == 'twitter-tweet'
          )
                      ? (_openBlock(), _createBlock(_component_IconComponent, {
                          key: 0,
                          className: "trademark ",
                          path: "",
                          icon: "icon-twitter.svg"
                        }))
                      : _createCommentVNode("", true),
                    (
            _ctx.addPostModel.postOnTwitter ||
            (_ctx.addPostModel.sourceType != 'data-team-tweets' &&
              _ctx.addPostModel.sourceType != 'twitter-tweet')
          )
                      ? (_openBlock(), _createBlock(_component_IconComponent, {
                          key: 1,
                          path: "",
                          className: "trademark ",
                          icon: "Header_Logo.svg"
                        }))
                      : _createCommentVNode("", true)
                  ], 64)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.momentTime), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}